import React, { useEffect, useState } from 'react';
import RequiredForSetting from './components/required-for-setting';
import AttachToFormNameSetting from './components/attach-to-form-name-setting';
import AddToCopyGroupSetting, { ADD_TO_COPY_GROUP_SETTING_KEY } from './components/add-to-copy-group-setting';
import PrintBorderSetting from './components/print-border-setting';

export const MultilineElementSettings = function FromElement({ element, handlerChangeOption, duplicateElement }) {
  const [label, setLabel] = useState(element.options.label);
  const [instructions, setInstructions] = useState(element.options.instructions);
  const [characterLimit, setCharacterLimit] = useState(element.options.characterLimit);
  const [alignment, setAlignment] = useState(element.options.alignment);
  const [size, setSize] = useState(element.options.size);
  const [labelPlacement, setLabelPlacement] = useState(element.options.labelPlacement || 'above');

  useEffect(() => {
    setLabel(element.options.label);
    setSize(element.options.size);
    setInstructions(element.options.instructions);
    setCharacterLimit(element.options.characterLimit);
    setAlignment(element.options.alignment);
    setLabelPlacement(element.options.labelPlacement);
  }, [element]);

  return (
    <div className="tabs-item">
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Label Alignment</h3>
        <div className="form-group">
          <span className="form-radio-button">
            <input
              type="radio"
              name="alignment"
              value="left"
              checked={alignment === 'left'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'alignment', element.id);
                setAlignment(e.target.value);
              }}
            />
            <span>Left</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="alignment"
              value="center"
              checked={alignment === 'center'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'alignment', element.id);
                setAlignment(e.target.value);
              }}
            />
            <span>Center</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="alignment"
              value="right"
              checked={alignment === 'right'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'alignment', element.id);
                setAlignment(e.target.value);
              }}
            />
            <span>Right</span>
          </span>
        </div>
      </div>

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Label Placement</h3>
        <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
          <div className="form-radio-button" style={{ display: 'block', flex: 1 }}>
            <input
              type="radio"
              name="labelPlacement"
              value="above"
              checked={labelPlacement === 'above'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'labelPlacement', element.id);
                setLabelPlacement(e.target.value);
              }}
            />
            <span style={{ textAlign: 'center', display: 'block' }}>Above</span>
          </div>
          <div className="form-radio-button" style={{ display: 'block', flex: 1 }}>
            <input
              type="radio"
              name="labelPlacement"
              value="left"
              checked={labelPlacement === 'left'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'labelPlacement', element.id);
                setLabelPlacement(e.target.value);
              }}
            />
            <span style={{ textAlign: 'center', display: 'block' }}>Left</span>
          </div>
        </div>
      </div>

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Input Size</h3>
        <div className="form-group">
          <span className="form-radio-button">
            <input
              type="radio"
              name="size"
              value="small"
              checked={size === 'small'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'size', element.id);
                setSize(e.target.value);
              }}
            />
            <span>Small</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="size"
              value="medium"
              checked={size === 'medium'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'size', element.id);
                setSize(e.target.value);
              }}
            />
            <span>Medium</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="size"
              value="large"
              checked={size === 'large'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'size', element.id);
                setSize(e.target.value);
              }}
            />
            <span>Large</span>
          </span>
        </div>
      </div>

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Name Label</h3>
        <div className="form-control-item">
          <input
            type="text"
            className="form-control"
            placeholder="Enter text"
            value={label}
            onChange={(e) => {
              setLabel(e.target.value);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'label', element.id);
              handlerChangeOption(e.target.value.replace(/ /g, '-').toLowerCase(), 'name', element.id);
            }}
          />
        </div>
      </div>

      <RequiredForSetting element={element} onChange={handlerChangeOption} submitter2Included />

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Instructions</h3>
        <div className="form-control-item">
          <textarea
            className="form-control"
            placeholder="Enter Instructions"
            value={instructions}
            onChange={(e) => {
              setInstructions(e.target.value);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'instructions', element.id);
            }}
          ></textarea>
        </div>
      </div>

      <AttachToFormNameSetting element={element} onChange={handlerChangeOption} />

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Character Limit</h3>
        <div className="form-control-item">
          <input
            type="number"
            className="form-control"
            placeholder="Enter Instructions"
            disabled={element.options.isFormName}
            value={characterLimit}
            onChange={(e) => {
              setCharacterLimit(e.target.value);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'characterLimit', element.id);
            }}
          />
        </div>
      </div>

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Initiator can edit text added by form creator</h3>
        <div className="form-switcher">
          <input
            type="checkbox"
            name="initiatorCanEdit"
            checked={Boolean(element?.options?.initiatorCanEdit)}
            onChange={(e) => {
              handlerChangeOption(e.target.checked, 'initiatorCanEdit', element.id);
            }}
          />
          <span>{element?.options?.initiatorCanEdit ? 'Yes' : 'No'}</span>
        </div>
      </div>
      <PrintBorderSetting element={element} onChange={handlerChangeOption} />
      <AddToCopyGroupSetting
        elementID={element?.id}
        selected={element?.options?.[ADD_TO_COPY_GROUP_SETTING_KEY]}
        onChange={handlerChangeOption}
      />
    </div>
  );
};
